import React, { useEffect, useState } from "react";
import { Card, Button, Table, Form, Alert } from "react-bootstrap";
import { IconList, IconLoader2, IconCheck, IconBan, IconAlertTriangle } from "@tabler/icons-react";
import { useNavigate, Link } from "react-router-dom";

const StatusFilterBar = ({ summary, activeFilter, setActiveFilter }) => {
  const total = summary.total || 0;

  const makeBlock = (label, value, status, Icon, color) => {
    const isActive = activeFilter === status;
    return (
      <div
        role="button"
        className="d-flex align-items-center text-start px-2"
        style={{
          cursor: "pointer",
          borderBottom: isActive ? "3px solid #206bc4" : "3px solid transparent",
          paddingBottom: "6px",
          minWidth: "220px"
        }}
        onClick={() => setActiveFilter(status)}
      >
        <Icon size={30} className={`me-2 ${color}`} />
        <div className="d-flex flex-column">
          <div style={{ fontSize: "14px", fontWeight: 600 }}>{label}</div>
          <div style={{ fontSize: "16px", fontWeight: 700 }} className="text-muted">
            {status === null ? value : `${value} (${total > 0 ? ((value / total) * 100).toFixed(2) : "0.00"}%)`}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="d-flex flex-wrap justify-content-start gap-2 mb-4 px-3">
      {makeBlock("All links", total, null, IconList, "text-secondary")}
      {makeBlock("Indexation in progress", summary.in_progress || 0, "Request in progress", IconLoader2, "text-info")}
      {makeBlock("Indexed", summary.indexed || 0, "Indexed", IconCheck, "text-success")}
      {makeBlock("Non indexed (Refunded)", summary.non_indexed || 0, "Non indexed (refunded)", IconBan, "text-danger")}
      {makeBlock("Non indexables (Refunded)", summary.non_indexables || 0, "Non indexable (refunded)", IconAlertTriangle, "text-warning")}
    </div>
  );
};

export default StatusFilterBar;
